import { render } from "./DialogMessageNew.vue?vue&type=template&id=117f4a9d"
import script from "./DialogMessageNew.vue?vue&type=script&lang=js"
export * from "./DialogMessageNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__